/* unplugin-vue-components disabled */import { _ as _async_to_generator } from "@swc/helpers/_/_async_to_generator";
import { _ as _ts_generator } from "@swc/helpers/_/_ts_generator";
import "core-js/modules/es.array.push.js";
import { useCreditStore } from '@/stores/modules/credit';
import { CreditStatus } from '@/shared/statusCode';
export default {
    __name: 'index',
    setup: function(__props) {
        var creditStore = useCreditStore();
        var router = useRouter();
        var init = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var creditStatus;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                creditStore.reqDictionary()
                            ];
                        case 1:
                            _state.sent();
                            if (!!creditStore.provinceDictionary) return [
                                3,
                                3
                            ];
                            return [
                                4,
                                creditStore.reqProviceDictionary()
                            ];
                        case 2:
                            _state.sent();
                            _state.label = 3;
                        case 3:
                            return [
                                4,
                                creditStore.reqBankTypeList()
                            ];
                        case 4:
                            _state.sent();
                            return [
                                4,
                                creditStore.reqCreditStatus()
                            ];
                        case 5:
                            creditStatus = _state.sent();
                            switch(creditStatus){
                                case CreditStatus.UNCREDITED:
                                case CreditStatus.NEED_FACE_RECOGNITION:
                                    toCreditPage();
                                    break;
                                case CreditStatus.CREDITING:
                                case CreditStatus.FACE_RECOGNITIONING_LIMIT_EXCEEDED:
                                    router.push('/result');
                                    break;
                                default:
                                    console.log('credit default', creditStatus);
                            }
                            return [
                                2
                            ];
                    }
                });
            });
            return function init() {
                return _ref.apply(this, arguments);
            };
        }();
        init();
        var toCreditPage = /*#__PURE__*/ function() {
            var _ref = _async_to_generator(function() {
                var routeObj;
                return _ts_generator(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                creditStore.reqCreditStep({})
                            ];
                        case 1:
                            routeObj = _state.sent();
                            router.push(routeObj);
                            return [
                                2
                            ];
                    }
                });
            });
            return function toCreditPage() {
                return _ref.apply(this, arguments);
            };
        }();
        return {
            __sfc: true,
            creditStore: creditStore,
            router: router,
            init: init,
            toCreditPage: toCreditPage
        };
    }
};
